import { MEDIUM_SCREEN } from '../../consts';
import { ARP_NAVIGATION_EVENTS } from '../../event_bus_modules/auction_registration_navigation';

$(() => {
  const body = $('body');
  const navigationContainer = $('#auction-registration-navigation-container');
  const navigationButton = $('#navigation-toggle-button');
  const nextButton = $('#auction-registration-next-button');
  const previousButton = $('#auction-registration-previous-button');
  let isMobile = window.innerWidth <= MEDIUM_SCREEN;

  const adjustMobileNavigation = () => {
    const isNowMobile = window.innerWidth <= MEDIUM_SCREEN;
    if (!isMobile && isNowMobile) {
      navigationContainer.addClass('hidden');
      body.removeClass('auction-registration-navigation-open');
    }
    if (isMobile && !isNowMobile) {
      navigationContainer.removeClass('hidden');
      body.addClass('auction-registration-navigation-open');
    }
    isMobile = isNowMobile;
  };

  const setInitialNavigationState = () => {
    if (isMobile) {
      navigationContainer.addClass('hidden');
      body.removeClass('auction-registration-navigation-open');
    } else {
      navigationContainer.removeClass('hidden');
      body.addClass('auction-registration-navigation-open');
    }
  };

  const onNavigationToggle = () => {
    navigationContainer.toggleClass('hidden');
    body.toggleClass('auction-registration-navigation-open');
    const isVisible = !navigationContainer.hasClass('hidden');
    if (isMobile && isVisible) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  nextButton.add(previousButton).add('.auction-link').on('click', () => {
    EVENT_BUS.dispatch(ARP_NAVIGATION_EVENTS.NAVIGATION_BUTTON_CLICK);
  });

  setInitialNavigationState();
  $(window).on('resize', adjustMobileNavigation);
  navigationButton.on('click', onNavigationToggle);
});
